import React from 'react'

import Modal from '../Modal/Modal'
import Terms from '../Terms/Terms'

const TermsModal = ({ show }) => {
  return (
    <Modal show={show}>
      <Terms />
    </Modal>
  )
}

export default TermsModal



// WEBPACK FOOTER //
// ./src/components/TermsModal/TermsModal.js